import "./Aside.0.css";
import { startMouseMove } from "../../lib/utils";
import { vueLinkLocalStorage } from "../../lib/utils/vue";
const pxToNumber = px => parseInt(px.replace('px', ''), 10);
const __script_base__ = {
  name: 'Aside',
  props: {
    width: {
      type: String,
      default: '340px'
    },
    minWidth: {
      type: String,
      default: '258px'
    },
    maxWidth: {
      type: String,
      default: '1000px'
    },
    position: {
      type: String,
      required: true
    },
    // left right
    saveExpanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extraWidth: 0,
      isExpanded: true
    };
  },
  created() {
    const lcKey = `aside:${this.$vnode.key}`;
    vueLinkLocalStorage(this, lcKey, 'extraWidth');
    if (this.saveExpanded) {
      vueLinkLocalStorage(this, lcKey, 'isExpanded');
    }
    if (this.isExpanded) this.$emit('expand');else this.$emit('collapse');
  },
  computed: {
    chevronDirection() {
      let toLeft = this.isExpanded;
      if (this.position === 'right') toLeft = !toLeft;
      return toLeft ? 'left' : 'right';
    },
    computedStyle() {
      const ans = {};
      ans.width = `calc(${this.width} + ${this.extraWidth}px)`;
      ans.minWidth = this.isExpanded ? this.minWidth : '0';
      ans.maxWidth = this.isExpanded ? this.maxWidth : '0';
      return ans;
    }
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) this.$emit('expand');else this.$emit('collapse');
    },
    startResize(event) {
      const o = this.extraWidth;
      const factor = this.position === 'left' ? 1 : -1;
      startMouseMove({
        initialEvent: event,
        onMove: ({
          deltaX
        }) => {
          this.extraWidth = o + factor * deltaX;
        },
        onEnd: () => {
          this.extraWidth = Math.max(pxToNumber(this.minWidth) - pxToNumber(this.width), this.extraWidth);
          this.extraWidth = Math.min(pxToNumber(this.maxWidth) - pxToNumber(this.width), this.extraWidth);
        }
      });
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-aside",
    class: {
      isExpanded: _vm.isExpanded
    },
    style: _vm.computedStyle,
    attrs: {
      "data-position": _vm.position
    }
  }, [_c("div", {
    staticClass: "ucd-aside-content",
    attrs: {
      "data-ucd-report-mod": "sidebar"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    staticClass: "ucd-aside-resizer",
    on: {
      mousedown: _vm.startResize,
      touchstart: _vm.startResize
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "ucd-aside-toggle",
    on: {
      click: _vm.toggle
    }
  }, [_c("i", {
    class: "fa fa-chevron-" + _vm.chevronDirection,
    attrs: {
      "aria-hidden": "true"
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/Aside.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);